<template>
  <div>
       <v-toolbar  elevation="1" color="secondary" dark>
        <v-img
                        src="@/assets/DRmed-02.png"
                        alt="DrMedPro"
                        class="logo-toolbar"
                        max-height="150"
                        max-width="250"
                    ></v-img>

        <v-spacer />

        <v-btn title="Ajuda" icon @click="retornarHelp()">
          <v-icon title="Ajuda">info</v-icon>
        </v-btn>

        <v-btn title="Logout" text icon color="primary" @click="logout()">
          <v-icon v-if="user.tecnico" title="Logout">logout</v-icon>
          <v-icon v-else title="Logout">power_settings_new</v-icon>
        </v-btn>
     </v-toolbar>

    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      app
      dark
      width="280"
      color="secondary"
      class="elevation-1"
    >
      <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-img :src="require('../assets/IconAdmin2.png')" />
        </v-list-item-avatar>

        <v-list-item-title class="font-weight-bold">
          {{ this.$store.getters.usuario.nome }}
        </v-list-item-title>

        <v-btn
          icon
          @click.stop="mini = !mini"
          class="ml-auto"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="{path:item.rota}"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          :value="true"
          prepend-icon="settings"
          color="primary"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Configurações</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(admin, i) in admins"
            :key="i"
            :to="{path:admin[2]}"
            link
          >
            <v-list-item-icon>
              <v-icon v-text="admin[1]"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="admin[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <template v-slot:append>
        <div class="pa-2 text-center caption grey--text">
          v{{ appVersion }}
        </div>
      </template>
    </v-navigation-drawer>

          <router-view/>
  </div>
</template>

<script>
import administradorUnidadeService from '../services/administradorUnidade.service'
import HelperAdministradorUnidade from './../components/helper/Helper'
import { getToken, setToken } from '../store/auth'

export default {
  name: 'App',
  components: {
    HelperAdministradorUnidade
  },
  data () {
    return {
      drawer: true,
      mini: false,
      appVersion: process.env.VUE_APP_VERSION || '1.0.0',
      dialogHelp: false,
      blockMethod: false,
      chamouListaHelp: false,
      listaHelp: [],
      intervalos: [],
      socket: null,
      admins: [
        ['Alterar nome', 'person', 'editarNomeAdministradorUnidade'],
        ['Alterar senha', 'vpn_key', 'editarSenhaAdministradorUnidade'],
        ['Alterar cor do card da unidade', 'color_lens', 'coresUnidade']
      ],
      items: [
        { title: 'Início', icon: 'dashboard', rota: '/dashboardUnidade' },
        { title: 'Médicos', icon: 'groups', rota: '/MetricasMedico' },
        { title: 'Técnicos', icon: 'enhanced_encryption', rota: '/listaTecnicosUnidade' },
        { title: 'Atendentes', icon: 'groups', rota: '/listaAtendentesUnidade' },
        { title: 'Recepcionistas', icon: 'groups', rota: '/listaRecepcionistasUnidade' },
        { title: 'Apoio', icon: 'person', rota: '/listaApoioUnidade' },
        { title: 'Usuarios', icon: 'person', rota: '/usuarios' },
        { title: 'Locais', icon: 'place', rota: '/listaLocaisUnidade' },
        { title: 'Serviços', icon: 'add', rota: '/servicosUnidade' },
        { title: 'Painéis', icon: 'tv', rota: '/listaPaineisUnidade' },
        { title: 'Painéis externos', icon: 'cast', rota: '/paineisExternos' }
      ],
      user: this.$store.getters.usuario
    }
  },
  created () {
    // Usar arrow function para manter o contexto
    const interval = setInterval(() => this.refreshToken(), 21600000)
    this.intervalos.push(interval)
    this.user = this.$store.getters.usuario
  },
  beforeDestroy () {
    this.limparIntervalos()
    if (this.socket) {
      this.socket.close()
      this.socket.disconnect()
    }
  },
  methods: {
    alterarDialogHelp () {
      this.dialogHelp = false
    },

    async refreshToken () {
      console.log('token antes:', getToken())

      try {
        const rsp = await administradorUnidadeService.administradorUnidade
          .refreshToken(getToken())

        console.log('rsp refreshToken', rsp)
        if (rsp.status == 200) {
          setToken(rsp.data.token)
          console.log('token dps', getToken())

          // Recriar socket se necessário
          if (this.socket) {
            this.socket.close()
            // this.socket = io.connect(socketService.SOCKET_URL, {
            //   query: {
            //     token: getToken()
            //   }
            // })
            // this.chamarSocket()
          }
        }
      } catch (err) {
        console.log('Erro ao refresh token:', err)
        // Em caso de erro no refresh, fazer logout
        this.logout()
      }
    },

    async retornarHelp () {
      if (this.blockMethod) return

      this.blockMethod = true
      try {
        if (this.chamouListaHelp) {
          this.dialogHelp = true
          this.blockMethod = false
          return
        }

        const rsp = await administradorUnidadeService.administradorUnidade
          .retornarHelp(this.user.tipo)

        console.log('rsp retornarHelp:', rsp)
        if (rsp.status == 200) {
          this.listaHelp = this.groupBy(rsp.data, 'idTituloHelp')
          this.chamouListaHelp = true
          this.dialogHelp = true
        }
      } catch (err) {
        console.log('Erro ao carregar help:', err)
      } finally {
        this.blockMethod = false
      }
    },

    limparIntervalos () {
      this.intervalos.forEach(interval => clearInterval(interval))
      this.intervalos = []
    },

    async logout () {
      try {
        await this.$store.dispatch('FedLogOut')
        this.limparIntervalos()

        if (this.socket) {
          this.socket.close()
          this.socket.disconnect()
        }

        // Redirecionar com fallback
        if (this.$router) {
          this.$router.push('/loginLocal')
        } else {
          window.location.href = '/login'
        }
      } catch (error) {
        console.log('Erro ao fazer logout:', error)
        window.location.href = '/login'
      }
    },

    groupBy (collection, property) {
      const result = []
      const values = []

      collection.forEach(item => {
        const val = item[property]
        const index = values.indexOf(val)
        if (index > -1) {
          result[index].push(item)
        } else {
          values.push(val)
          result.push([item])
        }
      })
      return result
    }
  }
}
</script>
<style scoped>
#font {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}

.v-navigation-drawer {
  border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.v-list-item--active {
  background-color: rgba(0, 123, 255, 0.1) !important;
}

.v-list-item--active .v-list-item__title {
  color: var(--v-primary-base) !important;
  font-weight: 500;
}

.v-list-item__icon {
  margin-right: 16px !important;
}

.v-list-group__items .v-list-item {
  padding-left: 40px !important;
}
</style>
